import axios from './configAxiosOrganizations';

export const putOrganization = async (orgId, requestData) => {
	return axios.put(`/${orgId}/update/`, requestData);
};
